export default __webpack_public_path__ + "static/synlab-1f6c4b13f150425436ca15514838d7b7.png";